import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { getId } from '../../helpers';

function CTableHead (props) {
  const { selectedRows = 0, noOfNonSelectableRows = 0, pagedData = [], colDef = [], sortBy = '', sortOrder = 'asc' } = props;
  const isIndeterminate = selectedRows.length > 0;
  const isCheckDisabled = noOfNonSelectableRows === pagedData.length;
  let isAllSelected = false;
  const isNonSelectableRowInPagedData = pagedData.find(fpd => fpd.default);

  if (noOfNonSelectableRows && isNonSelectableRowInPagedData) {
    const fSelRows = pagedData.filter(fpd => selectedRows.find(f => getId(f) === getId(fpd)));
    isAllSelected = fSelRows.length > 0 ? (fSelRows.length + noOfNonSelectableRows) === pagedData.length : false;
  } else {
    isAllSelected = pagedData.every(r => selectedRows.find(f => getId(f) === getId(r)));
  }

  function onChange (e) {
    if (e.target.checked) {
      props.onAllRowSelect(pagedData, noOfNonSelectableRows);
    } else {
      props.onAllRowSelect([], noOfNonSelectableRows);
    }
  }

  return (
    <TableHead>
      <TableRow>
        {
          props.onAllRowSelect
            ? (
              <TableCell padding='none'>
                <Checkbox disabled={isCheckDisabled} indeterminate={isIndeterminate && !isAllSelected} checked={isAllSelected} onChange={onChange} />
              </TableCell>
            )
            : null
        }
        {
          colDef
            .filter(col => !col.hidden)
            .map(({ title, filterType, field }) => (
              <TableCell key={title} sortDirection={sortBy === field ? sortOrder : false}>
                {
                  !filterType
                    ? (
                      <TableSortLabel
                        active={sortBy === field} direction={sortBy === field ? sortOrder : 'asc'} 
                        onClick={() => props.onSortChange(field)}>
                        {title}
                      </TableSortLabel>
                    )
                    : <>{title}</>
                }
              </TableCell>
            ))
        }
        {
          props.isExpandable
            ? (
              <TableCell />
            )
            : null
        }
      </TableRow>
    </TableHead>
  );
}

CTableHead.propTypes = {
  selectedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  noOfNonSelectableRows: PropTypes.number.isRequired,
  colDef: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortOrder: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  pagedData: PropTypes.arrayOf(PropTypes.object),
  isExpandable: PropTypes.bool,
  onAllRowSelect: PropTypes.func
};

export default memo(CTableHead);
